<template>
    <k-panel class="border">
        <k-panel-header slot="header">{{ $t("accountInformation") }}</k-panel-header>
        <k-panel-row>
            <div slot="left">{{ $t("firstName") }}</div>
            <div slot="right" class="font-bold">{{ $root.$data.investorProfile.firstName }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">{{ $t("lastName") }}</div>
            <div slot="right" class="font-bold">{{ $root.$data.investorProfile.lastName }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">{{ $t("email") }}</div>
            <div slot="right" class="font-bold">{{ $root.$data.investorProfile.email }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">{{ $t("phone") }}</div>
            <div slot="right" class="font-bold">{{ $root.$data.investorProfile.mobilePhone }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">{{ $t("accountNumber") }}</div>
            <div slot="right" class="font-bold">{{ $root.$data.investorProfile.number }}</div>
        </k-panel-row>
    </k-panel>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    }
}
</script>


